import kr from 'Kr/kr';
import HTMLClass from 'Kr/utils/HTMLClass';

export default class LinkClass extends kr.Module
{
    init() {
        this._exts = {
            'pdf': 'a--pdf',
            'zip': 'a--zip',
            'doc': 'a--doc',
            'docx': 'a--doc',
            'xls': 'a--xsl',
            'xlsx': 'a--xsl'
        }

        this.bind();
    }

    bind() {
        for (let i in this._exts) {
            const $els = document.querySelectorAll(`a[href$="${i}"]`);
            if ($els.length == 0) {
                continue;
            }
            $els.forEach(item => {
                HTMLClass.addClass(item, 'a--file');
                HTMLClass.addClass(item, this._exts[i]);
            });
        }
    }
}